{
    "save_changes": "Сохранить изменения",
    "add_date": "Добавить дату",
    "are_you_sure": "Вы уверены?",
    "text_placeholder": "Напишите свое сообщение здесь",
    "password": "Пароль",
    "has_left": "ушел",
    "password_input": "Введите новый пароль здесь",
    "has_commented_on": "прокомментировал",
    "video_not_ready": "Видео еще не готово.",
    "group_left": "Ты покинул группу !",
    "api_key": "Ключ API",
    "ask_delete_message": "Вы уверены, что хотите удалить это сообщение?",
    "the_message_from": "сообщение от",
    "changed_group_name": "изменил название группы",
    "has_joined": "присоединился",
    "title_placeholder": "Заголовок вашего сообщения (опционально)",
    "create_a_group": "Создать группу",
    "group_share_choice": "Какой группе вы хотите отправить это сообщение?",
    "email": "Электронная почта",
    "edit": "Редактировать",
    "password_reset_mail_sent": "Электронное письмо со сбросом пароля было отправлено !",
    "search_in_group": "поиск в этой группе",
    "upload_audio": "Добавить аудиофайл.",
    "search_without_result": "Ваш поиск не выявил ни одного сообщения.",
    "invitation_link": "Пригласительная ссылка",
    "passwords_dont_match": "Пароли не совпадают",
    "name": "Имя",
    "bookmark_removed": "Сообщение удалено из закладок !",
    "in": "в",
    "new_password_placeholder": "новый пароль",
    "upload_image": "Добавить фотографии",
    "User not found": "Пользователь не найден",
    "password_placeholder": "пароль",
    "delete": "Удалить",
    "to": "к",
    "publish_in_group": "опубликовать в группе",
    "remove_bookmark": "Удалить сообщение из закладки",
    "error_new_message": "При отправке вашего сообщения произошла ошибка.",
    "reset_invitation_link": "Сбросить ссылку на приглашение",
    "notifications": "уведомления",
    "reset_api_key": "Сбросьте ключ API (вы будете отключены)",
    "name_input": "Выбрать имя",
    "cancel_write": "Вы действительно хотите отменить отправку нового сообщения?",
    "upload_pdf": "Добавить pdf-файл",
    "forgot_password": "Вы забыли свой пароль?",
    "bookmark_added": "Сообщение добавлено в закладки !",
    "error_upload": "Во время загрузки произошла ошибка",
    "audio_not_ready": "Аудио еще не готово.",
    "upload_music": "Добавить музыку",
    "invitation_welcome": "Добро пожаловать на Zusam! Пожалуйста, зарегистрируйтесь, прежде чем присоединиться к группе.",
    "mark_all_as_read": "отметьте все как прочитанное",
    "lang": "язык",
    "group_updated": "Группа была обновлена!",
    "users": "пользователи",
    "email_input": "Заполните свой адрес электронной почты здесь",
    "error": "Произошла ошибка",
    "Invalid login/password": "Неверный логин и/или пароль",
    "logout": "Выход из системы",
    "groups": "Группы",
    "login": "Авторизоваться",
    "destroy_account": "Удалить свой аккаунт",
    "confirm_password_placeholder": "подтвердите пароль",
    "default_group": "Группа по умолчанию",
    "login_placeholder": "электронная почта",
    "upload_video": "Добавить видео",
    "settings": "Настройки",
    "multiple_photos_upload": "Произошла ошибка. Попробуйте загружать изображения по одному (это может произойти в некоторых браузерах)",
    "notification_emails": "Уведомления по электронной почте",
    "signup": "Войти",
    "notification_emails_stopped": "Уведомления по электронной почте остановлены !",
    "add_bookmark": "Добавить сообщение в закладки",
    "public_link": "общедоступная ссылка",
    "has_posted_in": "разместил в",
    "quit_group": "Покинуть группу",
    "settings_updated": "Ваши настройки были обновлены",
    "share_message": "поделиться сообщением",
    "empty_message": "Сообщение пустое и не может быть отправлено !",
    "bookmarks": "закладки"
}
